import { DefaultQueryParams } from '@frontend/api-utils';
import { EquipmentExtendedClient } from '@frontend/equipment/api';
import { EquipmentExtended, EquipmentStateName } from '@frontend/equipment/types';
import { useEffect, useState } from 'react';

import { LendingLongestInUseEquipmentsListCardProps } from './lending-longest-in-use-equipments-list-card.component';

const LIST_LIMIT = 5;

export const useLendingLongestInUseEquipmentsListCard = (props: LendingLongestInUseEquipmentsListCardProps) => {
    const [items, setItems] = useState<EquipmentExtended[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!props.accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        EquipmentExtendedClient.fetchEquipmentsExtended({
            [DefaultQueryParams.ACCOUNT_ID]: props.accountId,
            [DefaultQueryParams.SIZE]: String(LIST_LIMIT),
            [DefaultQueryParams.SORTFIELD]: 'update_timestamp',
            [DefaultQueryParams.SORTDIRECTION]: 'asc',
            state: EquipmentStateName.EQUIPMENT_IN_USE
        })
            .then((response) => {
                if (!cancelled) {
                    setItems(response.results ?? []);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setItems([]);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [props.accountId]);

    return { items, isLoading };
};
